import React, { FC } from 'react';
import { VariationView } from '@/types/product';
import type { Props } from './types';
import Image from './Image';
import ImageFinish from './ImageFinish';
import Material from './Material';
import MaterialDimensions from './MaterialDimensions';
import None from './None';
// import Normal from './Normal';
import SeatBackCushion from './SeatBackCushion';
import { getVariationViews } from './utils';

const componentByVariationView: Record<VariationView, FC<Props>> = {
  [VariationView.SeatBackCushion]: SeatBackCushion,
  [VariationView.Image]: Image,
  [VariationView.Normal]: Image, // same as image?
  [VariationView.ImageFinish]: ImageFinish,
  [VariationView.MaterialDimensions]: MaterialDimensions,
  [VariationView.Material]: Material,
  [VariationView.None]: None,
};

const BundleOptionProductSelector: FC<Props> = (props) => {
  const variationViews = getVariationViews(props.option);
  const Component = componentByVariationView[variationViews[0]];
  return <Component {...props} />;
};

export default BundleOptionProductSelector;
